"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var colors = _interopRequireWildcard(require("@cimpress/react-components/lib/colors"));

var _reactComponents = require("@cimpress/react-components");

var _Tooltip = _interopRequireDefault(require("@cimpress/react-components/lib/Tooltip"));

var _emotion = require("emotion");

var _Price = _interopRequireDefault(require("./Price"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-left: 3px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var dropdownSelectedStyle = (0, _emotion.css)(_templateObject());

var PricingTable =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(PricingTable, _Component);

  function PricingTable() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, PricingTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(PricingTable)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      selected: _this.props.results.show
    };

    _this.onDropdownSelection = function (value) {
      _this.setState({
        selected: value
      });
    };

    return _this;
  }

  (0, _createClass2.default)(PricingTable, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          quantities = _this$props.quantities,
          results = _this$props.results,
          addedQuantities = _this$props.addedQuantities,
          resetting = _this$props.resetting,
          priceMode = _this$props.priceMode,
          deletedIndex = _this$props.deletedIndex,
          width = _this$props.width;
      var data = results.data,
          isNotDropDown = results.isNotDropDown;
      var listItems = Object.keys(data).sort();
      var selectedData = data[this.state.selected];
      var shipErrorMessage = selectedData && selectedData.shippingErrorMessage ? _react.default.createElement("p", null, selectedData.shippingErrorMessage, " ", _react.default.createElement("br", null), ' ', selectedData.shippingNote ? selectedData.shippingNote : null) : null;
      var selectedDropdown = shipErrorMessage ? _react.default.createElement("div", null, _react.default.createElement(_Tooltip.default, {
        direction: "top",
        contents: shipErrorMessage
      }, _react.default.createElement(_reactComponents.Icon, {
        color: colors.teal.base,
        name: "infomation-circle-l",
        size: "1x"
      }), ' '), _react.default.createElement("span", {
        className: dropdownSelectedStyle
      }, this.state.selected.toUpperCase())) : this.state.selected.toUpperCase();
      return _react.default.createElement("div", {
        className: "pricing-column"
      }, _react.default.createElement("table", {
        className: "table table-striped pricing-table",
        style: {
          width: width
        }
      }, _react.default.createElement("thead", null, _react.default.createElement("tr", null, _react.default.createElement("th", {
        className: "pricing-cell header list-price"
      }, _react.default.createElement("div", {
        className: "custom-select"
      }, isNotDropDown ? _react.default.createElement("div", null, selectedDropdown) : _react.default.createElement(_reactComponents.Dropdown, {
        title: selectedDropdown,
        className: "drop-down-style"
      }, listItems.map(function (value) {
        return _react.default.createElement("a", {
          key: value,
          onClick: function onClick() {
            return _this2.onDropdownSelection(value);
          }
        }, value);
      })))))), _react.default.createElement("tbody", null, quantities.map(function (qty, qtyIdx) {
        var tableData = data[_this2.state.selected];
        var cellData = tableData.quantityBreaks ? tableData.quantityBreaks.find(function (quant) {
          return quant.quantity === qty;
        }) : null;
        var rowClass = 'pricing-row';

        if (addedQuantities && addedQuantities.includes(qty)) {
          rowClass += ' added-item';
        } else if (resetting || deletedIndex === qtyIdx) {
          rowClass += ' deleted-item';
        }

        return _react.default.createElement("tr", {
          key: qty,
          className: rowClass
        }, cellData ? _react.default.createElement(_Price.default, {
          key: "".concat(qty, "-").concat(Math.random()),
          price: cellData.price,
          currency: tableData.currency,
          quantity: qty,
          priceMode: priceMode,
          shippingPrice: cellData.shipping,
          shippingCurrency: tableData.shippingCurrency
        }) : _react.default.createElement(_Price.default, {
          key: "".concat(qty, "-").concat(Math.random())
        }));
      }))));
    }
  }]);
  return PricingTable;
}(_react.Component);

exports.default = PricingTable;
PricingTable.defaultProps = {
  width: '150px'
};